import { render, staticRenderFns } from "./AutoSuggestions.vue?vue&type=template&id=10921918&scoped=true"
import script from "./AutoSuggestions.vue?vue&type=script&lang=js"
export * from "./AutoSuggestions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10921918",
  null
  
)

export default component.exports